import React, { useState } from "react";
import styles from "./Query.module.css";
import { Box, VStack, Text, Heading, Button, Divider } from "@chakra-ui/react";
import { connect } from "react-redux";
import CustomModal from "../pages/Dashboardcomponents/Modal";

const Query = (props) => {
  const [answer, setAnswer] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [currentquery, setCurrentQuery] = useState("");

  const enterAnswer = (a, i) => {
    // if (a.index === i) {
    let lasttext = props.ace.current.editor.session.getLine(a.startrow);
    let textatpos = lasttext.substring(a.endCol, a.endCol - 2);
    if (a.ans === undefined && textatpos !== "") {
      if (!a.endcol) {
        props.ace.current.editor.session.insert(
          { row: a.endrow, column: a.endCol },
          "{"
        );
        props.ace.current.editor.session.insert(
          { row: a.endrow, column: a.endCol + 1 }, answer
        )
        props.ace.current.editor.session.insert(
          { row: a.endrow, column: a.endCol + answer.length + 1 },
          "}"
        );
        props.ace.current.editor.session.selection.moveTo(
          a.endrow,
          a.endCol + 1
        );
        props.ace.current.editor.focus();
      }
    } else {
      props.ace.current.editor.session.selection.setRange({
        start: { row: a.endrow, column: a.endCol },
        end: { row: a.endrow, column: a.endCol },
      });
      props.ace.current.editor.session.selection.moveTo(a.endrow, a.endCol - 1);
      props.ace.current.editor.session.insert({ row: a.endrow, column: a.endCol - 1 }, answer)
      // props.ace.current.editor.focus();
      // }
      props.ace.current.editor.scrollToLine(a.endrow);
    }
  };

  const scrollToPos = (a) => {
    if (a.ans) {
      props.ace.current.editor.scrollToLine(a.startrow);
    }
  };

  const handleInput = (e) => {
    setAnswer(e.target.value)
  }

  const handleSubmit = () => {
    enterAnswer(currentquery)
    setShowModal(false)
  }

  console.log(answer);

  return (
    <>
      <VStack overflow="auto" height="100%">
        {props.query && props.query.length > 0 ? (
          props.query.map((a, i) => {
            return (
              <div key={i} style={{ width: "100%" }}>
                {
                  <Box
                    key={i}
                    p="4"
                    cursor={a.ans ? "pointer" : ""}
                    onClick={() => scrollToPos(a)}
                    backgroundColor="transparent"
                    width="100%"
                    wordBreak="break"
                    mt="8px"
                    ml="5px"
                    textAlign="left"
                  >
                    <Heading
                      fontSize="16px"
                      padding="8px 0"
                      fontFamily="Roboto, sans-serif"
                      color="#fff"
                    >
                      {a.index === i ? `Q: ${a.qns}` : <></>}
                    </Heading>
                    {a.ans ? (
                      <Text color="#fff">{a.index === i ? `A: ${a.ans}` : <></>}</Text>
                    ) : (
                      // <Button onClick={() => enterAnswer(a, i)}>
                      <Button onClick={() => { setCurrentQuery(a); setShowModal(true) }}>
                        Click to add Answer
                      </Button>
                    )}
                  </Box>
                }
                <Divider />
              </div>
            );
          })
        ) : (
          <></>
        )}
      </VStack>
      <CustomModal show={showModal}>
        <div className={styles.modalouter}>
          <h1>Enter your Answer</h1>
          <input type="text" name="answer" onChange={(e) => handleInput(e)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleSubmit() } }} />
          <div className={styles.buttonsection}>
            <button onClick={handleSubmit}>Submit</button>
            <button onClick={() => setShowModal(false)}>close</button>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

const mapStateToProps = (state, ownProps) => ({
  query: state.queries.queries,
  ace: ownProps.ace,
});

export default connect(mapStateToProps, null)(Query);
